import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"
import _imports_0 from '../assets/img/line_btn.png'
import _imports_1 from '../assets/img/rule_btn.png'
import _imports_2 from '../assets/img/map.jpg'
import _imports_3 from '../assets/img/close_btn.png'
import _imports_4 from '../assets/img/seat_icon.png'
import _imports_5 from '../assets/img/run.gif'
import _imports_6 from '../assets/img/puzzle_btn.png'


const _hoisted_1 = { class: "page-puzzle page-container" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "puzzle-wrapper" }
const _hoisted_8 = { class: "puzzle-inner swiper" }
const _hoisted_9 = { class: "puzzle-container swiper-wrapper" }
const _hoisted_10 = { class: "swiper-slide" }
const _hoisted_11 = {
  key: 0,
  class: "info"
}
const _hoisted_12 = ["src"]
const _hoisted_13 = ["data-content"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "icon" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: ""
}, null, -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "tips" }, [
  /*#__PURE__*/_createElementVNode("p", null, "提示：选择下方景点，拖到这里，最少三个，最多九个。")
], -1)
const _hoisted_23 = ["data-content"]
const _hoisted_24 = { class: "mark-wrapper" }
const _hoisted_25 = { class: "mark-swiper swiper" }
const _hoisted_26 = { class: "swiper-wrapper" }
const _hoisted_27 = ["onTouchstart", "onTouchmove", "onTouchend", "onTouchcancel"]
const _hoisted_28 = ["data-content"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: ""
}, null, -1)
const _hoisted_30 = [
  _hoisted_29
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "line-btn",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.lineView && _ctx.lineView(...args)))
      }, _hoisted_4),
      _createElementVNode("div", {
        class: "rule-btn",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.ruleView && _ctx.ruleView(...args)))
      }, _hoisted_6)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("img", {
              class: "puzzle-map-img",
              onLoad: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.mapLoad && _ctx.mapLoad(...args))),
              src: _imports_2,
              alt: ""
            }, null, 32),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.seatList, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["puzzle-seat", [item.info && 'hold']]),
                style: _normalizeStyle({'transform': 'translate3d('+ item.pos[0] +'px, '+ item.pos[1] +'px, 0)'})
              }, [
                (item.info)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("img", {
                        class: "puzzle-img",
                        src: item.info.img,
                        alt: ""
                      }, null, 8, _hoisted_12),
                      _createElementVNode("span", {
                        style: _normalizeStyle({'bottom': item.info.dis ? item.info.dis + 'vw' : ''}),
                        "data-content": item.info.text
                      }, _toDisplayString(item.info.text), 13, _hoisted_13),
                      _withDirectives(_createElementVNode("div", {
                        class: "close",
                        onClick: ($event: any) => (_ctx.remove(index, $event))
                      }, _hoisted_16, 8, _hoisted_14), [
                        [_vShow, !_ctx.isCreating]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("div", _hoisted_17, _hoisted_19, 512), [
                  [_vShow, !_ctx.isCreating || item.info]
                ])
              ], 6))
            }), 256)),
            _createElementVNode("div", {
              class: "people",
              style: _normalizeStyle({opacity: _ctx.isCreating ? '1' : '0'})
            }, _hoisted_21, 4)
          ])
        ])
      ]),
      _hoisted_22
    ]),
    (_ctx.currentItem)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["selected-mark", [(_ctx.moveData.x || _ctx.moveData.y) && 'is-moving', _ctx.currentItem.isMoveEnd && 'is-move-end']]),
          style: _normalizeStyle({'left': _ctx.moveData.left + 'px', 'top': _ctx.moveData.top + 'px'})
        }, [
          _createElementVNode("div", {
            class: "mark-item",
            style: _normalizeStyle({'background-image': 'url('+ _ctx.currentItem.img +')'})
          }, [
            _createElementVNode("span", {
              "data-content": _ctx.currentItem.text
            }, _toDisplayString(_ctx.currentItem.text), 9, _hoisted_23)
          ], 4)
        ], 6))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["swiper-slide swiper-no-swiping", [item.selected && 'selected', item.isFilled && 'filled', item.isReleased && 'release']]),
              style: _normalizeStyle({'transform': 'translate3d('+ (item.selected ? _ctx.moveData.x : 0) +'px, '+ (item.selected ? _ctx.moveData.y : 0) +'px, 0)'}),
              onTouchstart: _withModifiers(($event: any) => (_ctx.selected(index, $event)), ["stop"]),
              onTouchmove: _withModifiers(($event: any) => (_ctx.markMove(index, $event)), ["stop"]),
              onTouchend: ($event: any) => (_ctx.moveEnd(index, $event)),
              onTouchcancel: ($event: any) => (_ctx.moveEnd(index, $event))
            }, [
              _createElementVNode("div", {
                class: "mark-item",
                style: _normalizeStyle({'background-image': 'url('+ item.img +')'})
              }, [
                _createElementVNode("span", {
                  "data-content": item.text
                }, _toDisplayString(item.text), 9, _hoisted_28)
              ], 4)
            ], 46, _hoisted_27))
          }), 256))
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["slide-btn prev-btn", [_ctx.activeIndex === 0 && 'disabled']]),
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.prev && _ctx.prev(...args)))
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["slide-btn next-btn", [_ctx.swiperIsEnd && 'disabled']]),
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)))
      }, null, 2)
    ]),
    _createElementVNode("div", {
      class: "btn",
      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.create && _ctx.create(...args)))
    }, _hoisted_30)
  ]))
}